"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnsDetailsPropTypes = void 0;
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
exports.columnsDetailsPropTypes = prop_types_1.default.objectOf(prop_types_1.default.shape({
    width: prop_types_1.default.number,
    defaultWidth: prop_types_1.default.number,
    maxWidth: prop_types_1.default.number,
}));
